import { LinearProgress } from "@material-ui/core";
import React, { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Modal } from "../../../../app/components";
import styled from "styled-components";
import { useSnackbar } from "../../../../app/contexts/snackbar.context";
import { useStudyPlan } from "../../../../app/contexts/study.context";
import OutlinedButton from "../../../../app/components/buttons/outlined";
import DangerousButton from "../../../../app/components/buttons/dangerous";

export const DeleteStudyPlanModal = ({
  deleteOpen,
  setDeleteOpen,
  scenarioStatus,
  studyPlanId,
}) => {
  const { fetchStudy, deleteStudy } = useStudyPlan();
  const [studyError, setStudyError] = useState(false);
  const [deletingStudy, setDeletingStudy] = useState(false);

  const { id } = useParams();
  const { showSnackbar } = useSnackbar();

  const redirect = async () => {
    await fetchStudy(id);
  };

  const deleteMessage = useMemo(() => {
    if (studyError)
      return "Enrollment Plan cannot be deleted. Please contact the Creator of the Enrollment Plan to delete and confirm the status is 'Draft'.";
    return `
        Are you sure you want to delete this Enrollment Plan?  This cannot be un-done and will remove all information related to this Enrollment Plan.
        `;
  }, [studyError]);

  const deleteStudyHandler = async () => {
    try {
      setDeletingStudy(true);
      if (!["Draft", "Draft-Combo"].includes(scenarioStatus))
        throw new Error("Failed to Delete Enrollment Plan");
      const res = await deleteStudy(id, studyPlanId);
      if (res.data.length && res.data[0].returnCode === "200") {
        setDeletingStudy(false);
        setDeleteOpen(false);
        showSnackbar("Deleted successfully", "success");
        redirect();
      } else throw new Error("Failed to Delete Enrollment Plan");
    } catch (err) {
      console.log(err);
      setStudyError(true);
      setDeletingStudy(false);
      showSnackbar("Failed to Delete Enrollment Plan", "error");
    }
  };

  const closeDeleteModal = () => {
    setDeleteOpen(false);
    setStudyError(false);
  };

  return (
    <Modal
      open={deleteOpen}
      onClose={closeDeleteModal}
      aria-labelledby="Delete Enrollment Plan"
      aria-describedby="Delete an Enrollment Plan"
      title="Delete Enrollment Plan"
    >
      <Container>
        {deletingStudy ? (
          <LinearProgress />
        ) : (
          <Message>{deleteMessage}</Message>
        )}
      </Container>
      <SideBySide>
        <OutlinedButton
          autoFocus
          onClick={closeDeleteModal}
          disabled={deletingStudy}
        >
          {studyError ? "Close" : "Cancel"}
        </OutlinedButton>
        {!studyError && (
          <DangerousButton
            disabled={deletingStudy}
            onClick={deleteStudyHandler}
          >
            DELETE
          </DangerousButton>
        )}
      </SideBySide>
    </Modal>
  );
};

const Message = styled.p`
  text-align: center;
  padding-top: 0rem;
`;

const Container = styled.div`
  display: grid;
  padding: 1rem;
  grid-gap: 2em;
`;

const SideBySide = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1em;
`;
